import { Grid } from "@mui/material";

import { useDynamicThemeAwareVariables } from "@/features/FormV2/hooks/useDynamicThemeAwareVariables";
import { ThemedDotSelector } from "@/features/FormV2/sharedComponents/ThemedItemBlock/ThemedMultipleImageDisplay/ThemedDotSelector";
import { FormButton } from "@/forms-design-system/FormButton";
import { ChevronLeft, ChevronRight } from "@/icons/outlined";

interface ThemedBottomSelectorProps {
  photoUrls: string[];
  displayedImageIndex: number;
  setSelectedIndex: (index: number) => void;
  goLeft: () => void;
  goRight: () => void;
  size: "small" | "medium" | "large";
  noArrows?: boolean;
}

export const ThemedBottomSelector = ({
  photoUrls,
  displayedImageIndex,
  setSelectedIndex,
  goLeft,
  goRight,
  size,
  noArrows,
}: ThemedBottomSelectorProps) => {
  const dynamicTheme = useDynamicThemeAwareVariables(({ formsPalette, mode }) => {
    return {
      fill: mode === "light" ? formsPalette.text.brand : formsPalette.text.moderate,
      fillDisabled: formsPalette.border.moderate,
    };
  });
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      {!noArrows && (
        <Grid item>
          <FormButton
            iconButton
            variant="ghost"
            size="small"
            disabled={displayedImageIndex === 0}
            onClick={goLeft}
            sx={{
              "& svg": {
                fill: dynamicTheme.fill,
              },
            }}
            startIcon={<ChevronLeft />}
          />
        </Grid>
      )}
      <Grid item xs>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={size === "large" ? 4 : size === "medium" ? 2 : 1}
        >
          {photoUrls.map((photoUrl, index) => (
            <Grid item key={index + photoUrl}>
              <ThemedDotSelector
                isSelected={displayedImageIndex === index}
                index={index}
                setSelectedIndex={setSelectedIndex}
                size={size}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
      {!noArrows && (
        <Grid item>
          <FormButton
            iconButton
            variant="ghost"
            size="small"
            disabled={displayedImageIndex + 1 >= photoUrls.length}
            onClick={goRight}
            sx={{
              "& svg": {
                fill: dynamicTheme.fill,
              },
            }}
            startIcon={<ChevronRight />}
          />
        </Grid>
      )}
    </Grid>
  );
};
